<template>
    <div class="">

        <!-- ══════════════════════════════════════════════════════════════════
             CASE 1: Provident Fund Only — no sidebar, no tabs, just renders
             ══════════════════════════════════════════════════════════════════ -->
        <div class="mt-1" v-if="$atl_company_package_title == 'Provident Fund Only'">
            <pf-reporting></pf-reporting>
        </div>

        <!-- ══════════════════════════════════════════════════════════════════
             CASE 2: Gratuity Fund Only — single sidebar link, single tab.
             Simple enough that numeric tabIndexRFParent is fine (1 tab, no drift).
             ══════════════════════════════════════════════════════════════════ -->
        <template v-if="$atl_company_package_title == 'Gratuity Fund Only'">
            <div class="row">
                <div class="col-md-3 custom-sidebar py-5">
                    <h4 class="side-navbar-title mb-4">Reporting</h4>
                    <div class="panel-group side-navbar">
                        <a href="#" target="_self" class="nav-link"
                            :class="{ active: tabIndexRFParent == 0 }"
                            @click.stop="open_item_selected(0)">GF Reports</a>
                    </div>
                </div>
                <div class="col-md-9 pr-0">
                    <div class="payroll-reporting-tab col-md-12" id="nav-tabContent-intro">
                        <b-tabs content-class="reports-tab-wrapper"
                            nav-wrapper-class="mb-2 reports-tab-nav-wrapper d-none"
                            v-model="tabIndexRFParent">
                            <b-tab lazy @click="handleChange()" title="GF Reports">
                                <div class="" v-if="gfenabled"> <!-- Rejwan: gf_unified -->
                                    <gf-reporting :pageurl="$api_url"></gf-reporting>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </template>

        <!-- ══════════════════════════════════════════════════════════════════
             CASE 3: Provident And Gratuity Fund Only — visible tab nav,
             no custom sidebar. Tabs are gated by pfenabled/gfenabled but
             nav is visible so users click headers directly.  Kept as-is.
             ══════════════════════════════════════════════════════════════════ -->
        <div class="mt-1" v-if="$atl_company_package_title == 'Provident And Gratuity Fund Only'">
            <h4 class="atlhr-dashboard-title mt-10 px-0 mb-4">Reporting<span>
                <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting</span>
            </h4>
            <div class="payroll-reporting-tab" id="nav-tabContent-intro">
                <b-tabs content-class="mt-3 reports-tab-wrapper"
                    nav-wrapper-class="mb-2 reports-tab-nav-wrapper"
                    v-model="tabIndexRFParent">
                    <b-tab lazy @click="handleChange()" title="PF Reports" v-if="pfenabled">
                        <div class="">
                            <pf-reporting></pf-reporting>
                        </div>
                    </b-tab>
                    <b-tab lazy @click="handleChange()" title="GF Reports" v-if="gfenabled">
                        <div class=""> <!-- Rejwan: gf_unified -->
                            <gf-reporting></gf-reporting>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>

        <!-- ══════════════════════════════════════════════════════════════════
             CASE 4: Everything else (the main reporting view).
             This is the only case where conditional tabs cause index drift:
             tab 6 (Leave Encashment) has v-if="addons.includes('LeaveAttendances')".
             Tab 7 (Accounting JV) uses v-show — always occupies a slot.
             All sidebar links now use string keys; tabIndex is computed.
             ══════════════════════════════════════════════════════════════════ -->
        <template v-if="$atl_company_package_title != 'Provident Fund Only'
                     && $atl_company_package_title != 'Gratuity Fund Only'
                     && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
            <div class="row">

                <!-- ── Sidebar ── -->
                <div class="col-md-3 custom-sidebar py-5">
                    <h4 class="side-navbar-title mb-4">Reporting</h4>
                    <div class="panel-group side-navbar">

                        <a href="#" target="_self" class="nav-link"
                            :class="{ active: currentTabKey === 'payroll_reports' }"
                            @click.stop="open_item_selected('payroll_reports')">Payroll Reports</a>

                        <a href="#" target="_self" class="nav-link"
                            :class="{ active: currentTabKey === 'tax_reports' }"
                            @click.stop="open_item_selected('tax_reports')">Tax Reports</a>

                        <template v-if="addons.includes('LeaveAttendances') || addons.includes('Roster')">
                            <a href="#" target="_self" class="nav-link"
                                :class="{ active: currentTabKey === 'leave_attendance' }"
                                @click.stop="open_item_selected('leave_attendance')">Leave &amp; Attendance Reports</a>
                        </template>

                        <!-- PF Reports group (collapsible) -->
                        <div class="panel panel-default" v-if="pfenabled">
                            <div class="panel-heading">
                                <h4 class="panel-title mb-0">
                                    <a :class="{ 'collapsed': !isInGroup('pf') }"
                                        data-toggle="collapse" href="#collapse1">PF Reports</a>
                                </h4>
                            </div>
                            <div id="collapse1" class="panel-collapse collapse"
                                :class="{ 'show': isInGroup('pf') }">
                                <ul class="list-group">
                                    <li class="list-group-item nav-item">
                                        <a href="#" class="dropdown-item"
                                            :class="{ active: currentTabKey === 'pf_reports' }"
                                            @click.stop="open_item_selected('pf_reports')">PF Reports</a>
                                    </li>
                                    <li class="list-group-item nav-item">
                                        <a href="#" class="dropdown-item"
                                            :class="{ active: currentTabKey === 'pf_profit_dist' }"
                                            @click.stop="open_item_selected('pf_profit_dist')">Profit Distribution</a>
                                    </li>
                                    <li class="list-group-item nav-item">
                                        <a href="#" class="dropdown-item"
                                            :class="{ active: currentTabKey === 'pf_advance_reports' }"
                                            @click.stop="open_item_selected('pf_advance_reports')">PF Advance Reports</a>
                                    </li>
                                    <li class="list-group-item nav-item">
                                        <a href="#" class="dropdown-item"
                                            :class="{ active: currentTabKey === 'pf_settlement_reports' }"
                                            @click.stop="open_item_selected('pf_settlement_reports')">PF Settlement Reports</a>
                                    </li>
                                    <!-- <li class="list-group-item nav-item">
                                        <a href="#" class="dropdown-item"
                                            :class="{ active: currentTabKey === 'pf_others' }"
                                            @click.stop="open_item_selected('pf_others')">Others</a>
                                    </li> -->
                                    <li class="list-group-item nav-item">
                                        <a href="#" class="dropdown-item"
                                            :class="{ active: currentTabKey === 'pf_auditor_reports' }"
                                            @click.stop="open_item_selected('pf_auditor_reports')">Auditors</a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <a href="#" target="_self" class="nav-link"
                            :class="{ active: currentTabKey === 'loan_advance_reports' }"
                            @click.stop="open_item_selected('loan_advance_reports')">Loan &amp; Advance Reports</a>

                        <a href="#" target="_self" class="nav-link"
                            :class="{ active: currentTabKey === 'variance_reports' }"
                            @click.stop="open_item_selected('variance_reports')">Variance Reports</a>

                        <template v-if="addons.includes('LeaveAttendances') || addons.includes('Roster')">
                            <a href="#" target="_self" class="nav-link"
                                :class="{ active: currentTabKey === 'leave_encashment' }"
                                @click.stop="open_item_selected('leave_encashment')">Leave Encashment Reports</a>
                        </template>

                        <!-- Accounting JV: tab uses v-show so it always occupies an index -->
                        <template v-if="cost_center_number > 1">
                            <a href="#" target="_self" class="nav-link"
                                :class="{ active: currentTabKey === 'accounting_jv' }"
                                @click.stop="open_item_selected('accounting_jv')">Accounting JV Reports</a>
                        </template>

                        <a href="#" target="_self" class="nav-link"
                            :class="{ active: currentTabKey === 'kpi_reports' }"
                            @click.stop="open_item_selected('kpi_reports')">KPI Reports</a>

                        <template v-if="gfenabled">
                            <a href="#" target="_self" class="nav-link"
                                :class="{ active: currentTabKey === 'gf_reports' }"
                                @click.stop="open_item_selected('gf_reports')">GF Reports</a>
                        </template>

                    </div>
                </div>

                <!-- ── Content ── -->
                <div class="col-md-9 pr-0">
                    <div class="payroll-reporting-tab col-md-12" id="nav-tabContent-intro">
                        <!--
                            Tab nav is hidden (d-none). Navigation is sidebar-only.
                            :value + @input keeps currentTabKey in sync with any
                            direct tab-header click (should not normally happen).
                        -->
                        <b-tabs content-class="reports-tab-wrapper"
                            nav-wrapper-class="mb-2 reports-tab-nav-wrapper d-none"
                            :value="tabIndex"
                            @input="onTabInput">

                            <!-- ────────────────────────────────────────────
                                 TAB: payroll_reports  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy @click="handleChange()">
                                <template active
                                    v-if="$atl_company_package_title != 'Provident Fund Only' && $acl['payroll/reports'] == 2"
                                    v-slot:title>Payroll Reports</template>
                                <template v-else active v-slot:title>
                                    <b-icon icon="lock-fill" aria-hidden="true" class="lock-icon-trz-tab"></b-icon>Payroll Reports
                                </template>

                                <template v-if="$atl_company_package_title != 'Provident Fund Only' && $acl['payroll/reports'] == 2">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Payroll Reports<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / Payroll Reports</span>
                                    </h4>
                                    <p style="font-size: 15px;" class="text-secondary pt-4">Get a clear picture of your monthly payroll. Use this information to understand your workforce better.</p>
                                    <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav" v-model="tabIndexRF">
                                        <b-tab lazy @click="handleChange()">
                                            <template #title>
                                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                    <img v-bind:src="$api_url+'/images/Monthly_Payroll_Report.png'" class="light-mode-icon"/>
                                                    <h5>Monthly Payroll Report</h5>
                                                    <p>This report shows total breakdown of any selected month's payroll including all pay and allowances and deductions per employee.</p>
                                                    <b-button class="btn btn-primary">View Report</b-button>
                                                </div>
                                            </template>
                                            <div>
                                                <monthly-payroll-report :key="tabKey" :customized_payroll_report_status="customized_payroll_report_status" :cost_center_number="cost_center_number"></monthly-payroll-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy @click="handleChange()">
                                            <template #title>
                                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                    <img v-bind:src="$api_url+'/images/Periodic_Payroll_Report.png'" class="light-mode-icon"/>
                                                    <h5>Periodic Payroll Report</h5>
                                                    <p>This report shows the aggregate breakdown of any selected period's payroll including all pay and allowances and deductions per employee.</p>
                                                    <b-button class="btn btn-primary">View Report</b-button>
                                                </div>
                                            </template>
                                            <div>
                                                <yearly-payroll-report :key="tabKey"></yearly-payroll-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy @click="handleChange()">
                                            <template #title>
                                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                    <img v-bind:src="$api_url+'/images/Comprehensive_Payroll_Report.png'" class="light-mode-icon"/>
                                                    <h5>Comprehensive Payroll Report</h5>
                                                    <p>This report shows the total salary breakdown of each selected period's payroll including all pay and allowances and deductions per employee.</p>
                                                    <b-button class="btn btn-primary">View Report</b-button>
                                                </div>
                                            </template>
                                            <div>
                                                <comprehensive-payroll-report :key="tabKey"></comprehensive-payroll-report>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </template>
                                <template v-else>
                                    <lock-template></lock-template>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: tax_reports  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy @click="handleChange()">
                                <template active
                                    v-if="$atl_company_package_title != 'Provident Fund Only' && $acl['tax/reports'] == 2"
                                    v-slot:title>Tax Reports</template>
                                <template v-else active v-slot:title>
                                    <b-icon icon="lock-fill" aria-hidden="true" class="lock-icon-trz-tab"></b-icon>Tax Reports
                                </template>

                                <template v-if="$atl_company_package_title != 'Provident Fund Only' && $acl['tax/reports'] == 2">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Tax Reports<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / Tax Reports</span>
                                    </h4>
                                    <p style="font-size: 15px;" class="text-secondary pt-4">Get a clear picture of your payroll taxes. Use this information to better understand your tax compliance.</p>
                                    <b-tabs content-class="mt-3" nav-wrapper-class="mt-4 reports-tab-nav" v-model="tabIndexRFTax">
                                        <b-tab lazy @click="handleChange()">
                                            <template #title>
                                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                    <img v-bind:src="$api_url+'/images/Monthly_Payroll_Report.png'" class="light-mode-icon"/>
                                                    <h5>Annual Tax Deducted at Source (TDS) Report</h5>
                                                    <p>This report shows the total tax deducted at source (TDS) of each employee during any selected fiscal year on a monthly view.</p>
                                                    <b-button class="btn btn-primary">View Report</b-button>
                                                </div>
                                            </template>
                                            <div>
                                                <tds-report :key="tabKey"></tds-report>
                                            </div>
                                        </b-tab>
                                        <b-tab @click="handleChange()">
                                            <template #title>
                                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                    <img v-bind:src="$api_url+'/images/Monthly_Payroll_Report.png'" class="light-mode-icon"/>
                                                    <h5>Monthly Tax Computation Sheet</h5>
                                                    <p>This report shows the entire income tax calculation of each employee for any selected month.</p>
                                                    <b-button class="btn btn-primary">View Report</b-button>
                                                </div>
                                            </template>
                                            <div>
                                                <tax-computation-sheet :key="tabKey"></tax-computation-sheet>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </template>
                                <template v-else>
                                    <lock-template></lock-template>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: leave_attendance  (always rendered — no v-if on this tab)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy title="Leaves & Attendance Reports">
                                <template v-if="addons.includes('Roster')">
                                    <div class="">
                                        <roster-reporting></roster-reporting>
                                    </div>
                                </template>
                                <template v-if="leaveenabled && $acl['leaveattendance/report'] == 2">
                                    <div class="">
                                        <leave-attendence-report></leave-attendence-report>
                                    </div>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: pf_reports  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy title="PF Reports" @click="handleChange()">
                                <template v-if="pfenabled">
                                    <div class="">
                                        <pf-reporting></pf-reporting>
                                    </div>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: loan_advance_reports  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab title="">
                                <template active
                                    v-if="$atl_company_package_title != 'Provident Fund Only' && $acl['loanadvance/report'] == 2"
                                    v-slot:title>Loan &amp; Advance Reports</template>
                                <template v-else active v-slot:title>
                                    <b-icon icon="lock-fill" aria-hidden="true" class="lock-icon-trz-tab"></b-icon>Loan &amp; Advance Reports
                                </template>
                                <template v-if="$acl['loanadvance/report'] == 2">
                                    <div class="">
                                        <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                            <loan-reporting></loan-reporting>
                                        </template>
                                        <template v-else>
                                            <lock-template></lock-template>
                                        </template>
                                    </div>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: variance_reports  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy @click="handleChange()">
                                <template active
                                    v-if="$atl_company_package_title != 'Provident Fund Only'
                                       && $atl_company_package_title != 'Gratuity Fund Only'
                                       && $atl_company_package_title != 'Provident And Gratuity Fund Only'
                                       && $acl['variance/reports'] == 2"
                                    v-slot:title>Variance Reports</template>
                                <template v-else active v-slot:title>
                                    <b-icon icon="lock-fill" aria-hidden="true" class="lock-icon-trz-tab"></b-icon>Variance Reports
                                </template>

                                <template v-if="$atl_company_package_title != 'Provident Fund Only'
                                             && $atl_company_package_title != 'Gratuity Fund Only'
                                             && $atl_company_package_title != 'Provident And Gratuity Fund Only'
                                             && $acl['variance/reports'] == 2">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Variance Reports<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / Variance Reports</span>
                                    </h4>
                                    <p style="font-size: 15px;" class="text-secondary pt-4">This report outlines the changes in payroll per employee from the previous month to the current month.</p>
                                    <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav" v-model="tabIndexRFvr">
                                        <b-tab lazy @click="handleChange()">
                                            <template #title>
                                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                    <img v-bind:src="$api_url+'/images/Monthly_Payroll_Report.png'" class="light-mode-icon"/>
                                                    <h5>Variance Report</h5>
                                                    <p>This report outlines the changes in payroll per employee from the previous month to the current month.</p>
                                                    <b-button @click="selectMonthYear('summary')" class="mt-3">View Summary Report</b-button>
                                                    <b-button @click="selectMonthYear('detailed')" class="mt-3">View Detailed Report</b-button>
                                                </div>
                                            </template>
                                            <div>
                                                <variance-report :vr_fiscal_year="vr_fiscal_year" :vr_month="vr_month" :vr_type="vr_type" :vr_month_to="vr_month_to" :key="tabKey"></variance-report>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </template>
                                <template v-else>
                                    <lock-template></lock-template>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: leave_encashment
                                 ⚠️  THE ONLY TRULY CONDITIONAL TAB (v-if).
                                 When absent, tabs 7–13 shift down by 1.
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy @click="handleChange()"
                                v-if="addons.includes('LeaveAttendances') || addons.includes('Roster')">
                                <template active
                                    v-if="$atl_company_package_title != 'Provident Fund Only'
                                       && $atl_company_package_title != 'Gratuity Fund Only'
                                       && $atl_company_package_title != 'Provident And Gratuity Fund Only'"
                                    v-slot:title>Leave Encashment Report</template>
                                <template v-else active v-slot:title>
                                    <b-icon icon="lock-fill" aria-hidden="true" class="lock-icon-trz-tab"></b-icon>Leave Encashment Report
                                </template>

                                <template v-if="$atl_company_package_title != 'Provident Fund Only'
                                             && $atl_company_package_title != 'Gratuity Fund Only'
                                             && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave Encashment Report<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / Leave Encashment Report</span>
                                    </h4>
                                    <p style="font-size: 15px;" class="text-secondary pt-4">This report outlines the number of leaves(days) can be encashed per employee based on the selected dates.</p>
                                    <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav">
                                        <b-tab lazy @click="handleChange()">
                                            <template #title>
                                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                    <img v-bind:src="$api_url+'/images/TDS-report-black.png'" class="light-mode-icon"/>
                                                    <h5>Leave Encashment Report</h5>
                                                    <p>This report outlines the number of leaves(days) can be encashed per employee based on the selected dates.</p>
                                                    <b-button class="mt-3">View Report</b-button>
                                                </div>
                                            </template>
                                            <div>
                                                <leave-encashment-report :key="tabKey"></leave-encashment-report>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </template>
                                <template v-else>
                                    <lock-template></lock-template>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: accounting_jv  (always rendered — v-show, not v-if)
                                 v-show hides the header visually but the tab still
                                 occupies its index slot in b-tabs.
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy @click="handleChange()" v-show="cost_center_number > 1">
                                <template active
                                    v-if="$atl_company_package_title != 'Provident Fund Only'
                                       && $atl_company_package_title != 'Gratuity Fund Only'
                                       && $atl_company_package_title != 'Provident And Gratuity Fund Only'
                                       && $acl['accounting/jv/reports'] == 2"
                                    v-slot:title>Accounting JV Reports</template>
                                <template v-else active v-slot:title>
                                    <b-icon icon="lock-fill" aria-hidden="true" class="lock-icon-trz-tab"></b-icon>Accounting JV Reports
                                </template>

                                <template v-if="$atl_company_package_title != 'Provident Fund Only'
                                             && $atl_company_package_title != 'Gratuity Fund Only'
                                             && $atl_company_package_title != 'Provident And Gratuity Fund Only'
                                             && $acl['accounting/jv/reports'] == 2">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Accounting JV Reports<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / Accounting JV Reports</span>
                                    </h4>
                                    <p style="font-size: 15px;" class="text-secondary pt-4">This report shows the Accounting JV reports of any selected month's approved payruns with the information of GL Account and Cost Center</p>
                                    <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav" v-model="tabIndexRFvr">
                                        <b-tab @click="handleChange()">
                                            <template #title>
                                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                                    <img v-bind:src="$api_url+'/images/TDS-report-black.png'" class="light-mode-icon"/>
                                                    <h5>Accounting JV Reports</h5>
                                                    <p>This report shows the Accounting JV reports of any selected month's approved payruns with the information of GL Account and Cost Center</p>
                                                    <b-button class="mt-3">View Report</b-button>
                                                </div>
                                            </template>
                                            <div class="ibox p-3">
                                                <accountingjv-report></accountingjv-report>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </template>
                                <template v-else>
                                    <lock-template></lock-template>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: kpi_reports  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy title="" @click="handleChange()">
                                <template active
                                    v-if="$atl_company_package_title != 'Provident Fund Only'"
                                    v-slot:title>KPI Reports</template>
                                <template v-else active v-slot:title>
                                    <b-icon icon="lock-fill" aria-hidden="true" class="lock-icon-trz-tab"></b-icon>KPI Reports
                                </template>
                                <div class="">
                                    <kpi-reports></kpi-reports>
                                </div>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: pf_profit_dist  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy @click="handleChange()" title="PF Profit Distribution Reports">
                                <template v-if="pfenabled">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Profit Distribution<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / PF Reports / Profit Distribution</span>
                                    </h4>
                                    <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav report-in-one-line">
                                        
                                        <!-- <template  v-if="$site_options && $site_options['pf_profit_distribute_type'] =='equal'">
                                            <b-tab lazy>
                                                <template #title>
                                                    <div class="row no-margin">
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                            <div class="row no-margin">
                                                                <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Profit Distribution Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div>
                                                    <pf-profit-distribute-report :pageurl="$api_url"></pf-profit-distribute-report>
                                                </div>
                                            </b-tab>
                                        </template>
                                        
                                        <template v-if="$site_options && $site_options['pf_profit_distribute_type'] =='cumilitive'">
                                            <b-tab lazy>
                                                <template #title>
                                                    <div class="row no-margin">
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                            <div class="row no-margin">
                                                                <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Profit Distribution Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div>
                                                    <pf-profit-distribute-report-new :pageurl="$api_url"></pf-profit-distribute-report-new>
                                                </div>
                                            </b-tab>
                                        </template>-->
                                        <template v-if="$atl_company_package_title != 'Provident Fund Only'">
                                            <b-tab lazy>
                                                <template #title>
                                                    <div class="row no-margin">
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                            <div class="row no-margin">
                                                                <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Profit Payable</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div>
                                                    <pf-profit-payable-report :pageurl="$api_url"></pf-profit-payable-report>
                                                </div>
                                            </b-tab>
                                        </template>
                                    </b-tabs>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: pf_advance_reports  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy @click="handleChange()" title="PF Advance Reports">
                                <template v-if="pfenabled">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">PF Advance Reports<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / PF Reports / PF Advance Reports</span>
                                    </h4>
                                    <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav report-in-one-line">
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">PF Advance Schedule for Individual</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-loan-schedule-report :pageurl="$api_url"></pf-loan-schedule-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">PF Advance Balance</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-loan-monthly-report :pageurl="$api_url"></pf-loan-monthly-report>
                                            </div>
                                        </b-tab>

                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">PF Advance Summery</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-loan-fiscal-report :pageurl="$api_url" :pf_settings="this.pf_settings"></pf-loan-fiscal-report>
                                            </div>
                                        </b-tab>

                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">PF Advance Awating for Disbursment</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-loan-awating-disbursement-report :pageurl="$api_url"></pf-loan-awating-disbursement-report>
                                            </div>
                                        </b-tab>

                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">PF Advance Disbursment Report</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-loan-disbursement-report :pageurl="$api_url"></pf-loan-disbursement-report>
                                            </div>
                                        </b-tab>

                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">PF Advance Deduction Exception Report</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-loan-deduction-exception-report :pageurl="$api_url"></pf-loan-deduction-exception-report>
                                            </div>
                                        </b-tab>

                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">PF Advance Manual Payment Report</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-loan-early-settlement-report :pageurl="$api_url"></pf-loan-early-settlement-report>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: pf_settlement_reports  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy @click="handleChange()" title="PF Settlement Reports">
                                <template v-if="pfenabled">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">PF Settlement Reports<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / PF Reports / PF Settlement Reports</span>
                                    </h4>
                                    <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav report-in-one-line">
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">Awating for Disbursment Report</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-settlement-awating-disbursment-report :pageurl="$api_url"></pf-settlement-awating-disbursment-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">Disbursed Settlement Report</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-settlement-disbursment-report :pageurl="$api_url"></pf-settlement-disbursment-report>
                                            </div>
                                        </b-tab>

                                         <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">Individual Settlement Report</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-individual-settlement-report :pageurl="$api_url"></pf-individual-settlement-report>
                                            </div>
                                        </b-tab>

                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">PF Settlement Report</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-settlement-report :pageurl="$api_url"></pf-settlement-report>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </template>
                            </b-tab>

                            <!-- ────────────────────────────────────────────
                                 TAB: pf_others  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <!-- <b-tab lazy @click="handleChange()" title="Others">
                                <template v-if="pfenabled">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Others<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / PF Reports / Others</span>
                                    </h4>
                                    <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav report-in-one-line">
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">Profit and Loss Statement</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-pl-report :pageurl="$api_url"></pf-pl-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin">
                                                    <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                        <div class="row no-margin">
                                                            <div class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                <h5 class="report_view_text px-2">Balance Sheet</h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-bs-report :pageurl="$api_url"></pf-bs-report>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </template>
                            </b-tab> -->

                            <!-- ────────────────────────────────────────────
                                 TAB: pf_others  (always rendered)
                                 ──────────────────────────────────────────── -->
                            
                            <b-tab lazy @click="handleChange()" title="Auditors">
                                <template v-if="pfenabled">
                                    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Auditors<span>
                                        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Reporting / PF Reports / Auditors</span>
                                    </h4>
                                    
                                    <b-tabs content-class="mt-3 reports-tab" nav-wrapper-class="mt-4 reports-tab-nav report-in-one-line">
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">
                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Active Members Age Wise Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <active-members-age-wise-report></active-members-age-wise-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Active Members Service Period Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <active-members-service-period-report></active-members-service-period-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Division Wise Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <active-members-division-wise-report></active-members-division-wise-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">PF Advance Summary Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-advance-summary-report></pf-advance-summary-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">PF Advance Status Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-advance-status-report></pf-advance-status-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Reasons for Taking Advance Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-advance-applied-age-wise-report></pf-advance-applied-age-wise-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">PF Advance Movement Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-advance-movement-report></pf-advance-movement-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Employee Bank Account And Nominee Details Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <employee-bank-account-nominee-details-report></employee-bank-account-nominee-details-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Employee Details Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <employee-details-report></employee-details-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Monthly PF Settlement Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                               <pf-monthly-settlement-report></pf-monthly-settlement-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Awaiting For Installment Deduction Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                               <awaiting-installment-deduction-report></awaiting-installment-deduction-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Monthly Loan Collection Report</h5> <!-- Mustafijur: 16-07-2026: fixed text Monthly Loan Collection Report -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                               <montly-loan-collection-report></montly-loan-collection-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Final Settlement Tracker Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                               <final-settlement-tracker-report></final-settlement-tracker-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Yearly PF Leaver Statement Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-yearly-leaver-report></pf-yearly-leaver-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">PF Advance Deduction List Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-loan-advance-deduction-list></pf-loan-advance-deduction-list>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">PF Member Movement Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-member-movement-report></pf-member-movement-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">PF Master Report</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-master-report></pf-master-report>
                                            </div>
                                        </b-tab>
                                        <b-tab lazy>
                                            <template #title>
                                                <div class="row no-margin ">
                                                    <template>
                                                        <div class="ibox clearfix col-md-12 px-0 mb-0">

                                                            <div class="row no-margin">
                                                                <div
                                                                    class="col-md-12 ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center py-2 border rounded employee_tab">
                                                                    <h5 class="report_view_text px-2">Advance Details Report as per Auditor</h5>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div>
                                                <pf-advance-details-report-as-per-auditor :pageurl="this.$api_url" :pf_settings="this.pf_settings"></pf-advance-details-report-as-per-auditor>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </template>
                            </b-tab>
                            <!-- ────────────────────────────────────────────
                                 TAB: gf_reports  (always rendered)
                                 ──────────────────────────────────────────── -->
                            <b-tab lazy @click="handleChange()" title="GF Reports">
                                <div class="" v-if="gfenabled"> <!-- Rejwan: gf_unified -->
                                    <gf-reporting :pageurl="$api_url"></gf-reporting>
                                </div>
                            </b-tab>

                        </b-tabs>
                    </div>

                    <!-- Month/Year picker modal (for Variance Reports) -->
                    <b-modal id="select-month-year" size="lg" scrollable hide-footer title="Select Month and Year">
                        <div class="form-group row">
                            <label for="name" class="col-md-4 col-form-label">Fiscal Year</label>
                            <div class="col-md-6">
                                <select id="year" v-model="vr_fiscal_year" name="year"
                                    v-on:change="setfiscalyear()" required class="form-control">
                                    <option v-for="pyr in payrunyears" :value="pyr.range">{{ pyr.range }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row" v-if="vr_fiscal_year != ''">
                            <label for="status" class="col-md-4 col-form-label">{{ month_from }}</label>
                            <div class="col-md-6">
                                <select id="month" v-model="vr_month" name="Month"
                                    v-on:change="setYearSegment()" required class="form-control">
                                    <option value="6">June {{ year_segment2 }}</option>
                                    <option value="5">May {{ year_segment2 }}</option>
                                    <option value="4">April {{ year_segment2 }}</option>
                                    <option value="3">March {{ year_segment2 }}</option>
                                    <option value="2">February {{ year_segment2 }}</option>
                                    <option value="1">January {{ year_segment2 }}</option>
                                    <option value="12">December {{ year_segment1 }}</option>
                                    <option value="11">November {{ year_segment1 }}</option>
                                    <option value="10">October {{ year_segment1 }}</option>
                                    <option value="9">September {{ year_segment1 }}</option>
                                    <option value="8">August {{ year_segment1 }}</option>
                                    <option value="7">July {{ year_segment1 }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row" v-if="vr_fiscal_year != '' && vr_month != ''">
                            <label for="status" class="col-md-4 col-form-label">{{ month_to }}</label>
                            <div class="col-md-6">
                                <select id="month_to" v-model="vr_month_to" name="Month"
                                    v-on:change="setYear()" required class="form-control"
                                    v-if="year_selected == '1'">
                                    <option value="6">June {{ year_segment2 }}</option>
                                    <option value="5">May {{ year_segment2 }}</option>
                                    <option value="4">April {{ year_segment2 }}</option>
                                    <option value="3">March {{ year_segment2 }}</option>
                                    <option value="2">February {{ year_segment2 }}</option>
                                    <option value="1">January {{ year_segment2 }}</option>
                                    <option v-if="vr_month < 12" value="12">December {{ year_segment1 }}</option>
                                    <option v-if="vr_month < 11" value="11">November {{ year_segment1 }}</option>
                                    <option v-if="vr_month < 10" value="10">October {{ year_segment1 }}</option>
                                    <option v-if="vr_month < 9" value="9">September {{ year_segment1 }}</option>
                                    <option v-if="vr_month < 8" value="8">August {{ year_segment1 }}</option>
                                    <option v-if="vr_month < 7" value="7">July {{ year_segment1 }}</option>
                                </select>
                                <select id="month_to" v-model="vr_month_to" name="Month"
                                    v-on:change="setYear()" required class="form-control"
                                    v-if="year_selected == '2'">
                                    <option v-if="vr_month < 6" value="6">June {{ year_segment2 }}</option>
                                    <option v-if="vr_month < 5" value="5">May {{ year_segment2 }}</option>
                                    <option v-if="vr_month < 4" value="4">April {{ year_segment2 }}</option>
                                    <option v-if="vr_month < 3" value="3">March {{ year_segment2 }}</option>
                                    <option v-if="vr_month < 2" value="2">February {{ year_segment2 }}</option>
                                    <option v-if="vr_month < 1" value="1">January {{ year_segment2 }}</option>
                                </select>
                            </div>
                        </div>
                    </b-modal>
                </div>
            </div>
        </template>

    </div>
</template>

<script>
/**
 * Tab groups for isInGroup() — drives the PF Reports sidebar collapse.
 * Only used in the main case (everything else).
 * Keys must match the keys in tabDefs (computed).
 */
const TAB_GROUPS = {
    // pf: ['pf_reports', 'pf_profit_dist', 'pf_advance_reports', 'pf_settlement_reports', 'pf_others'],
    pf: ['pf_reports', 'pf_profit_dist', 'pf_advance_reports', 'pf_settlement_reports', 'pf_auditor_reports'],
};

export default {

    mounted() {
        this.$refs.trzcalendar;
    },

    props: ['flag', 'pfenabled', 'gfenabled', 'leaveenabled'],

    components: {},

    data() {
        return {
            search: '',
            length: 20,
            pagination: { currentPage: 1, pages: 1 },
            empty_result: 'Fetching data..',
            fiscal_year: '',
            payroll_reporting_data: [],

            // ── Inner tab indexes (not affected by the key system) ──────────
            tabIndexRF: 0,
            tabIndexRFTax: 0,
            tabIndexRFvr: 0,

            // ── Simple-case tab index (GF Only, P&GF Only) ─────────────────
            // Not used in the main case — kept for backward compat.
            tabIndexRFParent: 0,

            // ── Main-case tab state ────────────────────────────────────────
            // currentTabKey is the source of truth; tabIndex is derived.
            // _pendingSessionIndex handles sessionStorage backward compat
            // (old data stored numeric indices; new data stores key strings).
            currentTabKey: 'payroll_reports',
            tabIndex: 0,
            _pendingSessionIndex: null,
            // ──────────────────────────────────────────────────────────────

            column_selected: [],
            payrunyears: [],

            tabKey: 0,
            year: '',
            year_segment1: '',
            year_segment2: '',
            vr_month: '',
            vr_month_to: '',
            vr_fiscal_year: '',
            year_selected: 0,
            vr_type: '',
            addons: [],
            month_from: 'Month From',
            month_to: 'Month To',

            cost_center_number: '',
            customized_payroll_report_status: '',

            pf_settings: {
                pf_year_end: { opt_value: 0, status: 0 },
                pf_profit_distribute_type: { opt_value: 'equal', status: 0 },
            },
        };
    },

    computed: {
        /**
         * Ordered registry of every <b-tab> in the main case template,
         * in EXACTLY the same order they appear in the DOM.
         *
         * `show` mirrors the outermost v-if (or v-show) on each <b-tab>:
         *   - v-if  → show is conditional (tab removed from DOM when false)
         *   - v-show → show: true  (tab still in DOM; only header is hidden)
         *   - no directive → show: true always
         *
         * Only used when $atl_company_package_title is the "everything else" case.
         */
        tabDefs() {
            return [
                { key: 'payroll_reports',       show: true },
                { key: 'tax_reports',           show: true },
                { key: 'leave_attendance',      show: true },           // no v-if on tab
                { key: 'pf_reports',            show: true },
                { key: 'loan_advance_reports',  show: true },
                { key: 'variance_reports',      show: true },
                // ⚠️  Only truly conditional tab — causes all subsequent drift
                { key: 'leave_encashment',      show: this.addons.includes('LeaveAttendances') || this.addons.includes('Roster') },
                // v-show — always occupies a slot even when header is hidden
                { key: 'accounting_jv',         show: true },
                { key: 'kpi_reports',           show: true },
                { key: 'pf_profit_dist',        show: true },
                { key: 'pf_advance_reports',    show: true },
                { key: 'pf_settlement_reports', show: true },
                // { key: 'pf_others',             show: true },
                { key: 'pf_auditor_reports',    show: true},
                { key: 'gf_reports',            show: true },
            ];
        },

        /**
         * Maps each visible tab key to its zero-based rendered index.
         * Recalculates whenever addons changes (async load).
         */
        keyToIndex() {
            const map = {};
            let idx = 0;
            for (const tab of this.tabDefs) {
                if (tab.show) map[tab.key] = idx++;
            }
            return map;
        },
    },

    watch: {
        /**
         * Fires when addons loads (changing leave_encashment visibility).
         * Applies any pending sessionStorage-restored numeric index first,
         * then keeps the active key's position in sync.
         */
        keyToIndex(newMap) {
            if (this._pendingSessionIndex !== null) {
                const visibleTabs = this.tabDefs.filter(t => t.show);
                const entry = visibleTabs[this._pendingSessionIndex];
                if (entry) {
                    this.currentTabKey = entry.key;
                    this.tabIndex = this._pendingSessionIndex;
                }
                this._pendingSessionIndex = null;
            } else {
                const idx = newMap[this.currentTabKey];
                if (idx !== undefined) {
                    this.tabIndex = idx;
                }
            }
        },
    },

    methods: {
        /**
         * Navigate to a tab by semantic key (main case) or numeric index
         * (simple cases: GF Only, P&GF Only — called with a number).
         */
        open_item_selected(keyOrIndex) {
            if (typeof keyOrIndex === 'number') {
                // Legacy path for simple cases (GF Only, P&GF Only).
                this.tabIndexRFParent = keyOrIndex;
            } else {
                // Main case: key-based navigation.
                const idx = this.keyToIndex[keyOrIndex];
                if (idx === undefined) {
                    console.warn(`[Reporting] Tab key "${keyOrIndex}" is not currently visible.`);
                    return;
                }
                this.currentTabKey = keyOrIndex;
                this.tabIndex = idx;
            }
        },

        /**
         * Handles direct tab-header clicks in the main case (nav is hidden,
         * kept for safety). Reverse-maps the numeric index back to a key.
         */
        onTabInput(idx) {
            const entry = this.tabDefs.filter(t => t.show)[idx];
            if (entry) {
                this.currentTabKey = entry.key;
                this.tabIndex = idx;
            }
        },

        /**
         * Returns true when the active tab belongs to the named group.
         * Used to keep collapsible sidebar panels open.
         */
        isInGroup(groupName) {
            const group = TAB_GROUPS[groupName];
            return group ? group.includes(this.currentTabKey) : false;
        },

        handleChange() {
            this.tabKey += 1;
            if (this.$cookies.isKey('report_column_selected')) {
                const val = this.$cookies.get('report_column_selected');
                if (val != null && val !== '') {
                    this.column_selected = Array.isArray(val) ? val : val.split(',');
                }
            }
        },

        handleChangeParent() {
            // Save the current key (new format) so restoration is key-based.
            sessionStorage.setItem('key_parent', this.currentTabKey);
            window.location.reload();
            if (this.$cookies.isKey('report_column_selected')) {
                const val = this.$cookies.get('report_column_selected');
                if (val != null && val !== '') {
                    this.column_selected = Array.isArray(val) ? val : val.split(',');
                }
            }
        },

        handleChangeTax(index) {
            window.location.reload();
            sessionStorage.setItem('key_tax', index);
        },

        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

        openMe() {
            this.$bvModal.show('view-details');
        },

        getCompanyAddons() {
            axios.get(this.$api_url + '/company/get-addons').then(response => {
                this.addons = response.data;
            });
        },

        getCostCenterNumber() {
            axios.get(this.$api_url + '/get_total_cost_center').then(response => {
                this.cost_center_number = response.data;
            });
        },

        selectMonthYear(type) {
            this.vr_month = '';
            this.vr_month_to = '';
            this.vr_fiscal_year = '';
            this.year_selected = 0;
            this.vr_type = type;
            this.month_from = type === 'summary' ? 'Month From' : 'First Month';
            this.month_to   = type === 'summary' ? 'Month To'   : 'Second Month';
            this.$bvModal.show('select-month-year');
        },

        getpayrunyears() {
            axios.get(this.$api_url + '/getpayrun-years', {
                params: { page: 1, per_page: 10, search_query: this.search, search_query_by_id: '' },
            }).then(response => {
                this.payrunyears = response.data;
            });
        },

        setfiscalyear() {
            const yr = this.vr_fiscal_year.split('-');
            this.year_segment1 = yr[0];
            this.year_segment2 = yr[1];
        },

        setYear() {
            this.$bvModal.hide('select-month-year');
        },

        setYearSegment() {
            this.year_selected = this.vr_month > 6 ? '1' : '2';
        },

        getCustomizedPayrollReportStatus() {
            axios.get(this.$api_url + '/get-customized-payroll-report-status/').then(response => {
                this.customized_payroll_report_status = response.data;
            });
        },
    },

    created() {
        this.fiscal_year = this.getCurrentFinancialYear();

        // ── Restore main-case tab from sessionStorage ────────────────────
        // New format: key string (e.g. 'payroll_reports').
        // Old format: numeric string (e.g. '3') — deferred until addons load.
        const savedParent = sessionStorage.getItem('key_parent');
        if (savedParent) {
            if (/^\d+$/.test(savedParent)) {
                // Old numeric format — defer to keyToIndex watcher.
                this._pendingSessionIndex = parseInt(savedParent);
            } else {
                // New key format — apply immediately.
                this.currentTabKey = savedParent;
                // tabIndex will be computed once keyToIndex is reactive.
            }
        }

        // ── Restore inner tab indexes ────────────────────────────────────
        const savedTax = sessionStorage.getItem('key_tax');
        const savedVr  = sessionStorage.getItem('key_vr');
        if (savedTax) this.tabIndexRFTax = parseInt(savedTax) || 0;
        if (savedVr)  this.tabIndexRFvr  = parseInt(savedVr)  || 0;

        this.getpayrunyears();
        this.getCompanyAddons();
        this.getCostCenterNumber();
        this.getCustomizedPayrollReportStatus();
    },

};
</script>
